// src/api/LessonResourceApi.js
import apiClient from "../utils/Http";

const buildFormData = (data) => {
  const formData = new FormData();
  for (const key in data) {
    const value = data[key];
    if (value === undefined || value === null) continue;
    formData.append(key, value);
  }
  return formData;
};

const hasFile = (data) =>
  typeof File !== 'undefined' && data?.file instanceof File;

export const createLessonResource = (data) => {
  if (hasFile(data)) {
    const formData = buildFormData(data);
    return apiClient.post('/api/lesson-resources/', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  }

  return apiClient.post('/api/lesson-resources/', data);
};

export const updateLessonResource = (id, data) => {
  if (hasFile(data)) {
    const formData = buildFormData(data);
    return apiClient.patch(`/api/lesson-resources/${id}/`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  }

  return apiClient.patch(`/api/lesson-resources/${id}/`, data);
};

export const getLessonResource = () =>
  apiClient.get('/api/lesson-resources/');

export const getLessonResourceById = (id) =>
  apiClient.get(`/api/lesson-resources/${id}/`);

export const getLessonResourceByLessonId = (lessonId) =>
  apiClient.get('/api/lesson-resources/', { params: { lesson: lessonId } });

export const deleteLessonResource = (id) =>
  apiClient.delete(`/api/lesson-resources/${id}/`);